<template>
  <div class="card">
    <h3 class="card-title">LISTAR ASIGNACIONES FAMILIARES</h3>
    <div>
      <a
        class="btn btn-sm btn-info d-flex center"
        download=""
        href="/AUTORIZACION OBLIGATORIA PARA EL COBRO DE AAFF.pdf"
        style="text-decoration: none"
      >
        <icon feather="download" style="height: 12px"></icon>
        Autorización del otro progenitor
      </a>
    </div>
    <template v-if="user.tipo === 'dev' || user.tipo === 'RRHH'">
      <DataTable
        ref="asignacionesTable"
        :showFilter="true"
        :header="headers"
        :body="body"
        :actionButton="actionButton2"
        :actionButton2="actionButton"
        :endpoint="getAsignacionesEndpoint"
        :customFilters="customFilters"
        @rowClicked="verAsignacionesFamiliares"
      >
        <template #custom-filter>
          <pd-input
            id="filterYear"
            label="Año"
            select
            v-model="filterYear"
            @input="updateTable"
            style="margin-left: 10px"
          >
            <template #options>
              <option value="">Todos los años</option>
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </template>
          </pd-input>

          <pd-input
            id="filterEstado"
            label="Estado"
            select
            v-model="filterEstado"
            @input="updateTable"
            style="margin-left: 10px"
          >
            <template #options>
              <option value="">Todos los estados</option>
              <option value="Aprobado">Aprobado</option>
              <option value="En revision">En revisión</option>
              <option value="Con observaciones">Con observaciones</option>
              <option value="Rechazado">Rechazado</option>
              <option value="Baja">Baja</option>
            </template>
          </pd-input>

          <suggest
            id="filterUsuario"
            label="Empleado"
            :value="selectedEmpleadoNombre"
            placeholder="Buscar empleado..."
            :data="usuarios"
            :items="usuariosList"
            @selected="empleadoSelected"
            style="margin-left: 10px; min-width: 200px"
          />
        </template>
      </DataTable>
    </template>
    <template v-else>
      <DataTable
        ref="asignacionesTable"
        :showFilter="true"
        :header="headers"
        :body="body"
        :actionButton="actionButton2"
        :endpoint="getAsignacionesEndpoint"
        :customFilters="customFilters"
        @rowClicked="verAsignacionesFamiliares"
      >
        <template #custom-filter>
          <pd-input
            id="filterYear"
            label="Año"
            select
            v-model="filterYear"
            @input="updateTable"
            style="margin-left: 10px"
          >
            <template #options>
              <option value="">Todos los años</option>
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </template>
          </pd-input>

          <pd-input
            id="filterEstado"
            label="Estado"
            select
            v-model="filterEstado"
            @input="updateTable"
            style="margin-left: 10px"
          >
            <template #options>
              <option value="">Todos los estados</option>
              <option value="Aprobado">Aprobado</option>
              <option value="En revision">En revisión</option>
              <option value="Con observaciones">Con observaciones</option>
              <option value="Rechazado">Rechazado</option>
              <option value="Baja">Baja</option>
            </template>
          </pd-input>
        </template>
      </DataTable>
    </template>
  </div>
</template>
<script>
import { asignacionesFamiliaresApi } from "@/modules/percepcionesAsignacionFamiliar/services/asignacionesFamiliaresApi";
import { TipoEstadoAsignacionConstants } from "@/modules/percepcionesAsignacionFamiliar/constants/tipoEstadoAsignacion";
import moment from "moment/moment";
import { TipoAsignacionConstants } from "@/modules/percepcionesAsignacionFamiliar/constants/tipoAsignacion";
import DataTable from "@/components/elements/DataTable.vue";
import Suggest from "@/components/elements/Suggest.vue";
import axios from "axios";
import { mapState } from "vuex";

export default {
  computed: {
    asignacionesFamiliaresApi() {
      return asignacionesFamiliaresApi;
    },
    ...mapState(["user"]),
    customFilters() {
      const filters = {};
      if (this.filterYear) filters.filterYear = parseInt(this.filterYear);
      if (this.filterEstado) filters.filterEstado = this.filterEstado;
      if (this.filterUsuario)
        filters.filterUsuario = parseInt(this.filterUsuario);
      return filters;
    },
  },
  components: { DataTable, Suggest },
  name: "ListarAsignacionesFamiliares",
  data() {
    return {
      asignacionesFamiliares: null,
      filterYear: this.$route.query.filterYear || "",
      filterEstado: this.$route.query.filterEstado || "",
      filterUsuario: this.$route.query.filterUsuario || "",
      selectedEmpleadoNombre: "",
      usuarios: [],
      usuariosList: [{ name: "nombre", class: "" }],
      years: [],
      headers: [
        {
          value: "Empleado",
          sortable: "percepcion_cargas_familias.nombre_empleado",
        },
        { value: "Tipo", sortable: "tipo_asignacion" },
        { value: "Año", sortable: "year" },
        { value: "Estado", sortable: "estado" },
        { value: "Fecha de carga", sortable: "changed_at" },
        { value: "Fecha de aprobación", sortable: "approved_at" },
      ],
      body: [
        {
          class: "w-100 important text-bold",
          data: [{ value: "user.nombre" }],
        },
        {
          class: "w-100 important",
          data: [
            {
              value: "tipo_asignacion",
              mutator(tipoAsignacion) {
                if (tipoAsignacion === TipoAsignacionConstants.MATERNIDAD) {
                  return `<span style="display: none">${tipoAsignacion}</span>`;
                }
                return `<span>${tipoAsignacion}</span>`;
              },
            },
            {
              value: "percepcion_maternidad",
              mutator(percepcion_maternidad) {
                if (percepcion_maternidad?.tipo_percepcion) {
                  return `<span>${percepcion_maternidad.tipo_percepcion}</span>`;
                }
                return `<span style="display: none"><span>`;
              },
            },
          ],
        },
        {
          class: "w-100 important text-bold",
          data: [
            {
              value: "year",
              mutator(year) {
                return year ?? "-";
              },
            },
          ],
        },
        {
          class: "important",
          data: [
            {
              value: "estado",
              mutator(estado) {
                if (estado === TipoEstadoAsignacionConstants.APROBADO) {
                  return `<b class="text-success">${estado}</b>`;
                }
                if (estado === TipoEstadoAsignacionConstants.EN_REVISION) {
                  return `<b class="text-primary">${estado}</b>`;
                }
                if (
                  estado === TipoEstadoAsignacionConstants.CON_OBSERVACIONES
                ) {
                  return `<b class="text-warning">${estado}</b>`;
                }
                if (estado === TipoEstadoAsignacionConstants.RECHAZADO) {
                  return `<b class="text-danger">${estado}</b>`;
                }
                if (estado === TipoEstadoAsignacionConstants.BAJA) {
                  return `<b class="text-danger">${estado}</b>`;
                }
              },
            },
          ],
        },
        {
          class: "important",
          data: [
            {
              value: "changed_at",
              mutator: this.normalDate,
            },
          ],
        },
        {
          class: "important",
          data: [
            {
              value: "approved_at",
              mutator: this.normalDate,
            },
          ],
        },
      ],
      actionButton: {
        text: "Crear DDJJ Maternidad",
        action: () => {
          this.$router.push({ name: "CrearPercepcionMaternidad" });
        },
      },
      actionButton2: {
        text: "Crear DDJJ Cargas familia",
        action: () => {
          this.$router.push({ name: "CrearPercepcionCargasFamilia" });
        },
      },
    };
  },
  mounted() {
    // Generar años desde 2020 hasta el año actual
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2020; year--) {
      this.years.push(year);
    }

    // Cargar usuarios para el suggest
    if (this.user.tipo === "dev" || this.user.tipo === "RRHH") {
      axios.get("users").then((response) => {
        this.usuarios = response.data;
        // Cargar nombre del empleado si hay filterUsuario en query params
        if (this.filterUsuario) {
          const usuario = this.usuarios.find((u) => u.id == this.filterUsuario);
          if (usuario) {
            this.selectedEmpleadoNombre = usuario.nombre;
          }
        }
      });
    }

    asignacionesFamiliaresApi.getAll().then((asignacionesFamiliares) => {
      this.asignacionesFamiliares = asignacionesFamiliares;
    });
  },
  methods: {
    normalDate(value) {
      if (!value) {
        return "-";
      }
      let date = moment(value);
      return date.format("DD/MM/YYYY");
    },
    verAsignacionesFamiliares(asignacionFamiliar) {
      this.$router.push({
        name: "VerAsignacionesFamiliares",
        params: { id: asignacionFamiliar.id },
      });
    },
    getAsignacionesEndpoint(filter) {
      const params = { ...filter };
      if (this.filterYear) params.filterYear = this.filterYear;
      if (this.filterEstado) params.filterEstado = this.filterEstado;
      if (this.filterUsuario) params.filterUsuario = this.filterUsuario;
      return asignacionesFamiliaresApi.getAll(params);
    },
    updateTable() {
      this.$refs.asignacionesTable.refresh();
    },
    empleadoSelected(empleado) {
      if (empleado && empleado.id) {
        this.filterUsuario = empleado.id.toString();
        this.selectedEmpleadoNombre = empleado.nombre;
      } else {
        this.filterUsuario = "";
        this.selectedEmpleadoNombre = "";
      }
      this.updateTable();
    },
  },
};
</script>

<style scoped>
::v-deep .form-control {
  height: 38px !important;
  box-sizing: border-box;
}
::v-deep .suggest-container .form-control {
  height: 38px !important;
}
</style>
